import {CSSProperties, FC, ReactNode} from 'react'
import {StyledCloseButton, StyledModal, StyledOverlay} from '@components/ui/modal/style.ts'
import {XCloseIcon} from '@components/ui/icon/Icon.tsx'
import {createPortal} from 'react-dom'
import {useTranslation} from 'react-i18next'

interface ModalProps {
    children: ReactNode
    className?: string
    closeIconOffset?: 'sm' | 'md' | 'lg'
    onClose?: () => void
    onOverlayClick?: () => void
    showCloseButton?: boolean
    width?: CSSProperties['width']
}

export const Modal: FC<ModalProps> = ({
    children,
    className,
    closeIconOffset = 'md',
    onClose,
    onOverlayClick,
    width
}) => {
    const {i18n} = useTranslation()

    return createPortal(
        <>
            <StyledOverlay onClick={onOverlayClick} />
            <StyledModal width={width} className={className}>
                {onClose && (
                    <StyledCloseButton
                        dir={i18n.dir()}
                        size="lg"
                        variant="ghost"
                        onClick={onClose}
                        $closeIconOffset={closeIconOffset}
                        shape={'square'}
                    >
                        <XCloseIcon />
                    </StyledCloseButton>
                )}
                {children}
            </StyledModal>
        </>,
        document.body
    )
}

Modal.displayName = 'Modal'
